function Placemat({ children }: { children: React.ReactNode }) {
  return (
    <div className="lg:my-16 my-4 lg:mx-auto mx-4 lg:mt-8 p-8 max-w-screen-lg bg-white rounded-lg border border-column-gray-100 shadow-column-2">
      {children}
    </div>
  );
}

export default Placemat;
